import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum DealPhaseServiceEnum {
  phaseApprove = "/approve",
}

export default class DealPhaseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/deal/phase");
  }

  public putInPhaseApprove = async data => await this.PUT(DealPhaseServiceEnum.phaseApprove, data);
}
